import React from 'react';
import { string } from 'prop-types';
import { DEFAULT_LOCATION_IMAGE } from './constants';
import { LocationImg } from './styles';
import { useImageService } from '@kyruus/image-component';

/**
 * Non-clickable version of LocationImage component for ploc locations
 */
function NonClickableLocationImage({ imgUrl = DEFAULT_LOCATION_IMAGE }) {
  const { config } = useImageService();

  return (
    <div data-testid="MapCardNonClickableLocationImage">
      <LocationImg
        src={imgUrl}
        alt="Location"
        desiredHeight={150}
        desiredWidth={267}
        enhancementEnabled={config?.enableEnhancement || false}
        data-testid="location-image"
      />
    </div>
  );
}

NonClickableLocationImage.propTypes = {
  imgUrl: string
};

export default NonClickableLocationImage;
